import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useRecordContext } from 'react-admin';
import { List, TopToolbar, CreateButton, ExportButton, Button, Datagrid, TextField} from 'react-admin';

import IconAddCircle from '@material-ui/icons/AddCircle';

import App from '../../../../app.js';

const NameField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [value, setValue] = useState(theapp.t('loading'));

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession()

		if (record.isLocalOnly)
			return record.localname;
		else 
			return mvcmydashboard.getERC20TokenName(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setValue(value);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<div>{value}</div>);
};

NameField.defaultProps = { label: 'Name' };

const SymbolField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [value, setValue] = useState(theapp.t('loading'));

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession()

		if (record.isLocalOnly)
			return record.localsymbol;
		else 
			return mvcmydashboard.getERC20TokenSymbol(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setValue(value);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<div>{value}</div>);
};

SymbolField.defaultProps = { label: 'Symbol' };


const TotalSupplyField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [value, setValue] = useState(theapp.t('loading'));

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession()

		if (record.isLocalOnly)
			return record.localtotalsupply;
		else 
			return mvcmydashboard.getERC20TokenTotalSupply(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setValue(value);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<div>{value}</div>);
};

TotalSupplyField.defaultProps = { label: 'TotalSupply' };

const DecimalsField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [value, setValue] = useState(theapp.t('loading'));

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession()

		if (record.isLocalOnly)
			return record.localdecimals;
		else 
			return mvcmydashboard.getERC20TokenDecimals(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setValue(value);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<div>{value}</div>);
};

DecimalsField.defaultProps = { label: 'Decimals' };

const StatusField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [value, setValue] = useState('');

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession()

		if (record.isLocalOnly)
			return record.statusstring;
		else 
			return mvcmydashboard.getERC20TokenStatusString(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setValue(value);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<div>{value}</div>);
};


StatusField.defaultProps = { label: 'Status' };

// import button
const ImportButton = (props) => {
	//const record = useRecordContext();

	/*<CreateButton basePath='/erc20tokens' icon={<IconAddCircle/>} label="Import" />*/
	return (
		<Button
			label="Import"
			component={Link}
			to={{
				pathname: '/erc20tokens/create',
				state: { ctx: { type: 'import' } },
			}}
			>
				<IconAddCircle/>
		</Button>
	);

};

const ERC20TokenListActions = (props) => (
    <TopToolbar>
		<CreateButton/>
		<ImportButton/>
		<ExportButton/>
    </TopToolbar>
);
export const ERC20TokenList = props => (
	<List {...props} actions={<ERC20TokenListActions/>} >
		<Datagrid rowClick="show">
			<TextField source="localdescription" />
			<NameField />
			<SymbolField />
			<TotalSupplyField />
			<DecimalsField />
			<StatusField />
		</Datagrid>
	</List>
);